<template>
  <v-container>
    <div class="edit_user">
      <h1>ユーザ編集</h1>
      <div class="forms">
        <div class="input_form">
            <p>ユーザーID</p>
            <input type="text" placeholder="ユーザーID" class="form-control" v-model="user.userId"/>
        </div>
        <div class="input_form">
            <p>パスワード</p>
            <input type="text" placeholder="パスワード" class="form-control" v-model="user.password"/>
        </div>
        <div class="input_form">
            <p>サブドメイン</p>
            <input type="text" placeholder="サブドメイン" class="form-control" v-model="user.subdomain"/>
        </div>
        <div class="input_form">
            <p>顧客No</p>
            <input type="text" placeholder="ユーザー名" class="form-control" v-model="user.clientId"/>
        </div>            
        <div class="input_form">
            <p>契約者名</p>
            <input type="text" placeholder="ユーザー名" class="form-control" v-model="user.company"/>
        </div>
        <div class="input_form">
            <p>登録名</p>
            <input type="text" placeholder="ユーザー名" class="form-control" v-model="user.name"/>
        </div>
        <div class="input_form">
            <p>ルーム数上限</p>
            <input type="number" class="form-control" v-model="user.roomTotal"/>
        </div>
        <div class="input_form">
            <p>保存ルーム数</p>
            <input type="number" class="form-control" v-model="user.roomcount"/>
        </div>
        <div class="input_form">
            <p>ワンタイムルーム時間（契約）</p>
            <input type="number" class="form-control" v-model="user.randomroomcount"/>
        </div>
        <div class="input_form">
            <p>ワンタイムルーム時間（残量）</p>
            <input type="number" class="form-control" v-model="user.randomroomRemain"/>
        </div>
        <div class="input_form">
            <p>ワンタイムルームパスワード</p>
            <input type="text" class="form-control" v-model="user.randomroomPassword"/>
        </div>
        <div class="input_form">
            <v-select
            :items="plans"
            label="契約プラン"
            v-model="user.plan"
            ></v-select>
        </div>
        <div>
            <div v-if="uploadImageUrlLogo" class="domain-photo" @dragenter.stop="dragEnter(0)" @dragleave.stop="dragLeave(0)" @dragover.prevent @drop.prevent="dropFile(0)">
                <img class="domain-photo-image" :src="this.uploadImageUrlLogo" />
            </div>
            <div v-else class="domain-photo-frame" :class="{enter: isEnterLogo}" @dragenter.stop="dragEnter(0)" @dragleave.stop="dragLeaveL(0)" @dragover.prevent @drop.prevent="dropFile(0)">
                ロゴファイルアップロード
            </div>
            <v-file-input v-model="inputImageLogo"
                accept="image/*"
                show-size
                label="ロゴファイルをアップロードしてください"
                prepend-icon="mdi-image"
                @change="onImagePicked(0)">
            </v-file-input>
        </div>
        <div>
            <div v-if="uploadImageUrlBg" class="domain-photo" @dragenter.stop="dragEnter(1)" @dragleave.stop="dragLeave(1)" @dragover.prevent @drop.prevent="dropFile(1)">
                <img class="domain-photo-image" :src="this.uploadImageUrlBg" />
            </div>
            <div v-else class="domain-photo-frame" :class="{enter: isEnterBg}" @dragenter.stop="dragEnter(1)" @dragleave.stop="dragLeaveL(1)" @dragover.prevent @drop.prevent="dropFile(1)">
                背景ファイルアップロード
            </div>
            <v-file-input v-model="inputImageBg"
                accept="image/*"
                show-size
                label="背景ファイルをアップロードしてください"
                prepend-icon="mdi-image"
                @change="onImagePicked(1)">
            </v-file-input>
        </div>        
        <div class="buttons">
          <button type="button" class="btn btn-primary" @click="editUser" value="保存">保存</button>
          <button type="button" class="btn btn-secondary" @click="$router.push('/admintop');" value="戻る">戻る</button>
          <button type="button" class="btn btn-danger" @click="deleteClick" value="削除">削除</button>
        </div>
      </div>
    </div>
    <!-- メッセージモーダル -->
    <modal :name="messageModalName">
        <div class="modal-header">
            インフォメーション
        </div>
        <div class="modal-body">
            <p>{{ msg }}</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="$modal.hide(messageModalName)">閉じる</button>
            <button type="button" class="btn btn-secondary" @click="$router.push('/admintop');" value="戻る">戻る</button>
        </div>        
    </modal>    
    <!-- エラーモーダル -->
    <modal :name="errorModalName">
        <div class="modal-header">
            エラー
        </div>
        <div class="modal-body">
            <p>{{ msg }}</p>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="$modal.hide(errorModalName)">閉じる</button>
        </div>
    </modal>
    <!-- 確認モーダル -->
    <modal :name="confirmModalName">
        <div class="modal-header">
            確認
        </div>
        <div class="modal-body">
            <p>{{ msg }}</p>
        </div>
        <div class="modal-footer">
            <div class="buttons">
                <button type="button" class="btn btn-secondary" @click="$modal.hide(confirmModalName)">Cancel</button>
                <button type="button" class="btn btn-primary" @click="deleteUser();$modal.hide(confirmModalName)">OK</button>
            </div>
        </div>
    </modal>
  </v-container>
</template>

<script>
export default {
    data() {
        return {
            user: {},
            userId: 0,
            messageModalName: 'message_modal',            
            confirmModalName: 'confirm_modal',
            errorModalName: 'error_modal',
            msg: '',
            plans: [
             "BASIC",
             "PLEMIUM",
             "PRO"
            ],
            uploadImageUrlLogo: null,
            inputImageLogo: null,
            isEnterLogo: false,
            uploadImageUrlBg: null,
            inputImageBg: null,
            isEnterBg: false,            
        }
    },
    methods: {
        async editUser() {  
            this.user = this.adjustUser(this.user);
            let res = await this.$axios.post('/editUser/' + JSON.stringify(this.user));
            // メッセージがある場合は表示のみ行う
            if (res.data.msg) {
                this.msg = res.data.msg;
                this.$modal.show(this.errorModalName);
                return;
            }

            if( this.inputImageLogo != null ){
                const headers = { "content-type": "multipart/form-data" };
                let params = new FormData();
                params.append('file', this.inputImageLogo);
                res = await this.$axios.post('/uploadUserLogo/' + JSON.stringify(this.user), params, { headers });
            }

            if( this.inputImageBg != null ){
                const headers = { "content-type": "multipart/form-data" };
                let params = new FormData();
                params.append('file', this.inputImageBg);
                res = await this.$axios.post('/uploadUserBg/' + JSON.stringify(this.user), params, { headers });
            }
            if (res.status === 200) {
                //this.$router.push('/admintop');
                this.msg = "保存に成功しました";
                this.$modal.show(this.messageModalName);
                this.fetchUser();
            }
            else {
                this.msg = "保存に失敗しました";
                this.$modal.show(this.errorModalName);
            }
        },
        deleteClick() {
            this.msg = "本当に削除してもよろしいですか？";
            this.$modal.show(this.confirmModalName);
        },
        deleteUser() {
            this.$axios.post('/deleteUser/' + this.user.id)
                .then(res => {
                    if (res.status === 200) {
                        this.$router.push('/admintop');
                    }
                })
                .catch((err) => {
                    console.log(err)
                });
        },
        fetchUser() {
            if( this.userId != undefined ){
                this.$axios.get('/find/user/' + this.userId)
                    .then(res => {
                        this.user = this.adjustUser(res.data.user);
                        if(this.user.bg ){
                            this.uploadImageUrlBg = "/uploads/" + this.user.bg;
                        }
                        if(this.user.logo ){
                            this.uploadImageUrlLogo = "/uploads/" + this.user.logo;
                        }                    
                    })
                    .catch((err) => {
                        console.log(err)
                    });
            }
        },
        dragEnter(type) {
            if( type == 0 ){
                this.isEnterLogo = true;
            }
            else {
                this.isEnterBg = true;
            }
        },
        dragLeave(type) {
            if( type == 0 ){
                this.isEnterLogo = false;
            }
            else {
                this.isEnterBg = false;
            }
        },
		dropFile(type) {
            if( type == 0 ){
                this.isEnterLogo = false;
            }
            else {
                this.isEnterBg = false;
            }            
			let files = [...event.dataTransfer.files];
			if( files.length > 0){
                if( type == 0 ){
                    this.inputImageLogo = files[0];
                }
                else {
                    this.inputImageBg = files[0];
                }                  
				this.onImagePicked(type, files[0]);
			}
		},
        onImagePicked(type, file) {
            if (file !== undefined && file !== null) {
                if (file.name.lastIndexOf('.') <= 0) {
					return
                }
                const fr = new FileReader()
                fr.readAsDataURL(file)
                fr.addEventListener('load', () => {
                    if( type == 0 ){
                        this.uploadImageUrlLogo = fr.result;
                    }
                    else {
                        this.uploadImageUrlBg = fr.result;
                    }  
                })
            } else {
                if( type == 0 ){
                    this.uploadImageUrlLogo = '';
                }
                else {
                    this.uploadImageUrlBg = '';
                }  
            }
        },
    },
    created: function() {
        this.existUser();
        this.userId = this.$route.params.id;
        this.fetchUser();
    },
}
</script>

<style>
    .edit_user {
        margin-top: 100px;
    }
    
    .edit_user h1 {
        font-size: 30px;
        text-align: center;
        margin-bottom: 30px;
    }
    
    .edit_user .forms {
        max-width: 500px;
        margin: auto;
    }
    
    .edit_user .input_form {
        margin-bottom: 30px;
    }
    
    .edit_user button {
        color: white;
        margin-right: 10px;
    }
    
    .edit_user .buttons {
        text-align: right;
    }

    .modal-body button {
        color: white;
        margin-right: 10px;
    }
    
    .modal-body .buttons {
        text-align: right;
    }

    .domain-photo {
        width: 100%;
        height: 188px;
    }

    .domain-photo-image{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }

    .domain-photo-frame {
        border: dotted 1px #cccccc!important;
        border-radius: 5px;
        width: 100%;
        height: 188px;
        justify-content: center;
        align-items: center;
        display: flex;
    }

    .enter {
        border: 1px dotted blue;
        background-color: blue;
    }
</style>
